import { createCRUDHook } from './createCRUDHook';
import { PlyListDto } from 'utils/models';
import { TLKP_PLY_MATRIX } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PlyListDto>({
  entityName: 'Ply',
  endpoint: TLKP_PLY_MATRIX,
});

export const PlyContext = Context;
export const usePlyManager = useManager;
export const usePly = useConsumer;
